import PropTypes from 'prop-types'
import React from 'react'
import './SearchBlocoDeNotas.scss'
const rootClassName = 'component-search-bloco-de-notas'

export default function SearchBlocoDeNotas(props) {
  return (
    <div className={rootClassName}>
      <input
        onChange={(evt) => {
          if (typeof props.onChange === 'function') {
            props.onChange(evt)
          }
        }}
        value={props.value}
        placeholder={props.placeholder}
      />
      <div className={`${rootClassName}-right-object`}>{props.rightObject}</div>
    </div>
  )
}

SearchBlocoDeNotas.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  rightObject: PropTypes.object
}

SearchBlocoDeNotas.defaultProps = {
  value: ''
}
